import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';

type Props = RouteComponentProps<{}, {}, { session?: string; isSuccess?: boolean }>;

export const SessionBookedRedirectPage: React.FC<Props> = ({ location, history }) => {
    const session = location?.state?.session;

    useEffect(() => {
        history.push({
            pathname: '/payments/session-review',
            state: {
                session,
                isSuccess: true,
            },
        });
    }, [history, session]);

    return <div></div>;
};

export default SessionBookedRedirectPage;
